import {InviteValidationResult, LegalDocumentAction} from '../models/IRegistration';

const request = async <T>(path: string, body: object): Promise<T> => {
    const response = await fetch(`${process.env.REACT_APP_BASE_API_URL}${path}`, {
        method: 'POST',
        credentials: 'include',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify(body),
    });
    if (!response.ok) {
        let data: unknown;
        try { data = await response.json(); } catch { data = undefined; }
        throw {status: response.status, data};
    }
    if (response.status === 204 || response.headers.get('content-length') === '0') return undefined as T;
    return response.json() as Promise<T>;
};

// These calls deliberately bypass Redux so the invitation secret never appears
// in RTK Query state or Redux DevTools.
export const validateRegistrationInvite = (token: string) =>
    request<InviteValidationResult>('registration-invites/validate', {token});

export const registerWithInvite = (token: string, password: string, confirmPassword: string, legalDocumentActions: LegalDocumentAction[]) =>
    request<void>('registration-invites/register', {token, password, confirmPassword, legalDocumentActions});
